export enum AllowedFiletypes {
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PDF = 'application/pdf',
  PNG = 'image/png',
}

export const ALLOWED_FILE_TYPES = [
  AllowedFiletypes.JPEG,
  AllowedFiletypes.JPG,
  AllowedFiletypes.PNG,
  AllowedFiletypes.PDF,
];
